// extracted by mini-css-extract-plugin
export var csatScore = "_ip-5";
export var header = "_ip-1";
export var panelWrapper = "_ip-2";
export var postPreview = "_ip-3";
export var rightContent = "_ip-0";
export var wrappingText = "_ip-4";